import LetterDetail from "src/views/UserPage/Letter/LetterDetail";
import {LetterItems, LetterItemsList} from "src/styles/views/UserPage/letter";
import {CustomBtn} from "src/styles/common/CommonForm/buttonform";
import {COLOR} from "src/service/constant/color";
import React, {useEffect} from "react";
import {useLocation} from "react-router";
import {useLetterDataQueryData} from "src/hooks/reactquery";
import {TYPE_LifeDataList} from "src/service/constant/cmdtype";
import {useMoreButton} from "src/hooks/useMoreButton";
import {useNavigate} from "react-router-dom";
import useWindowDimensions from "src/hooks/useGetWindowSize";

const LetterLife = () => {
    const [more, onChangeMore, setMore] = useMoreButton(0)
    const {data: LetterListData, isSuccess} = useLetterDataQueryData(TYPE_LifeDataList, more)
    const {pathname} = useLocation()
    const navigate = useNavigate()
    const {width} = useWindowDimensions()

    useEffect(() => {
        setMore(0)
    }, [setMore])
    return (
        <>
            {pathname?.indexOf('detail') > 0 ?
                <LetterDetail detailInfo={'life'}/> :
                <>
                    <LetterItemsList>
                        {isSuccess && LetterListData?.Body?.map((element: { Title: string, ImgPath: string, Idx: number }, index: number) => (
                            <LetterItems key={index}
                                         onClick={() => navigate(`/userPage/letter/life/detail/${element.Idx}`)}>
                                <img src={element?.ImgPath} alt=""/>
                                <p>{element?.Title}</p>
                            </LetterItems>
                        ))}
                    </LetterItemsList>
                    {LetterListData?.Body?.length >= (more + 1) * 6 &&
                        <CustomBtn
                            className={width > 1200 ? "health_btn_pc" : "health_btn_mo"}
                            color={COLOR.point1}
                            bgColor={COLOR.white}
                            borderColor={COLOR.point1}
                            borderRadius={"40px"}
                            marginTop={width > 1200 ? "51px" : "24px"}
                            width={width > 1200 ? "356px" : "328px"}
                            height={width > 1200 ? "56px" : "44px"}
                            fontSize={width > 1200 ? "18px" : "14px"}
                            fontFamily={width > 1200 ? "NanumSquareNeoHeavy, sans-serif" : "NotoSansBold, sans-serif"}
                            onClick={onChangeMore}
                        >
                            <span>더보기</span>
                        </CustomBtn>
                    }
                </>
            }
        </>
    )
}
export default LetterLife